import { h, hydrate } from "preact";
import { Slider } from "./slider/index";
import { getSlidesDataById } from "./utils";

function init() {
  const root = document.getElementById("index-slider-wrapper");  
  if (!root) return;
  const { slides } = getSlidesDataById("slider-template-data");

  hydrate(<Slider slides={slides} />, root);
}

$(() => init());
